
import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/lang/index'
import plugins from './plugins'

import Directives from '@/directives'
import LoadScript from '@yld/yun-utils-vue-plugin-load-script'
import '@/styles/index.scss' // gl
import Element from 'element-ui'
import '@/styles/element-variables.scss'

import YunIcon from '@yld/yun-icon'
import './assets/element.scss'
import '@/permission'

import App from './App.vue'

// 注册所有插件
Vue.use(YunIcon)
Vue.use(Directives)
Vue.use(LoadScript)
Vue.use(plugins)
Vue.use(Element, {
  size: 'small',
  zIndex: 3000
})
Vue.prototype.$appId = '90031'
Vue.config.devtools = true
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
